import { render, staticRenderFns } from "./dateEditor.vue?vue&type=template&id=32996c46&"
import script from "./dateEditor.vue?vue&type=script&lang=js&"
export * from "./dateEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports